module.exports = "/images/b1d6bbb30b52fab4948cdfbf5cbee720.png";